module.exports = __webpack_public_path__ + "static/media/KatherineMoss.6e5995c7.svg";